module.exports = __webpack_public_path__ + "img/IndianMan.53e363bd.png";